<template>
  <p>
    Installation:
    <span v-if="isInstallationPossible">Possible</span>
    <span v-else>Not Possible</span>
  </p>
  <RadioGroup
    v-model="installation"
    name="installation"
    :yes-label="installationYesLabel"
    :disabled="!isInstallationPossible"
  />
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";

import { useNewEstimateStore } from "@/stores/new/estimateStore";
import { useDictStore } from "@/stores/dictStore";
import { useDistanceStore } from "@/modules/shipping/store/distance.store";
import RadioGroup from "@/shared/ui/RadioGroup.vue";

const dictStore = useDictStore();
const estimateStore = useNewEstimateStore();

const installation = defineModel<boolean>("installation");
const state = defineModel<string>("state");

const isInstallationPossible = ref(false);
const installationYesLabel = computed(() =>
  isInstallationPossible.value ? "Yes" : "Impossible",
);

const maxDistanceHours = 5; // Maximum distance in hours for installation to be possible
const distanceStore = useDistanceStore();
const distanceRoundedTime = computed(
  () => distanceStore.distance?.rounded_time,
);
const shippingZip = computed(() => estimateStore.estimate.shippingZip);

watch(
  () => [state.value, shippingZip.value],
  ([newState]) => {
    if (newState) {
      const isInstallationInState = dictStore.findState(newState)?.installation;

      if (isInstallationInState && !estimateStore.estimate.delivery) {
        installation.value = true;
        isInstallationPossible.value = true;
        return;
      }
      if (isInstallationInState && estimateStore.estimate.delivery) {
        installation.value = false;
        isInstallationPossible.value = true;
        return;
      }

      installation.value = false;
      isInstallationPossible.value = false;
    }
  },
  {
    immediate: true,
  },
);

watch(
  () => distanceRoundedTime?.value,
  (newValue) => {
    if (newValue && newValue > maxDistanceHours) {
      isInstallationPossible.value = false;
      installation.value = false;
    }
  },
);

watch(
  () => installation?.value,
  (installation) => {
    distanceStore.fetchDistance(shippingZip.value, installation);
  },
);
</script>

<style scoped></style>
